import { createMemoryHistory, createRouter } from 'vue-router'
import HomeView from './views/HomeView.vue'
import LibraryView from './views/LibraryView.vue'
import SearchView from './views/SearchView.vue'
import ContentDetailView from './views/ContentDetailView.vue'
import MeetingsView from './views/MeetingsView.vue'
import MeetingDetailView from './views/MeetingDetailView.vue'
import MessagesView from './views/MessagesView.vue'
import ProfileView from './views/ProfileView.vue'
import LoginView from './views/LoginView.vue'
import IdentityGuideView from './views/IdentityGuideView.vue'
import EmployeeCiamView from './views/EmployeeCiamView.vue'
import VerificationView from './views/VerificationView.vue'
import OnboardingView from './views/OnboardingView.vue'
import MediaDetailView from './views/MediaDetailView.vue'
import SurveyView from './views/SurveyView.vue'
import LearningView from './views/LearningView.vue'
import MedicalServiceView from './views/MedicalServiceView.vue'
import ServicesView from './views/ServicesView.vue'
import MeetingJourneyView from './views/MeetingJourneyView.vue'
import ConsentSettingsView from './views/ConsentSettingsView.vue'

const router = createRouter({
  history: createMemoryHistory(import.meta.env.BASE_URL),
  scrollBehavior: () => ({ top: 0 }),
  routes: [
    { path: '/login', name: 'login', component: LoginView, meta: { shell: false, title: '登录与隐私同意' } },
    { path: '/identity', name: 'identity', component: IdentityGuideView, meta: { shell: false, title: '选择身份类型' } },
    { path: '/ciam', name: 'ciam', component: EmployeeCiamView, meta: { shell: false, title: '员工身份验证' } },
    { path: '/hcp-check', redirect: '/duc-register' },
    { path: '/duc-register', name: 'duc-register', component: VerificationView, meta: { shell: false, title: '医学从业人员个人信息' } },
    { path: '/verify', redirect: '/duc-register' },
    { path: '/onboarding', name: 'onboarding', component: OnboardingView, meta: { shell: false, title: '偏好初始化' } },
    { path: '/', name: 'home', component: HomeView, meta: { title: '首页' } },
    { path: '/library', name: 'library', component: LibraryView, meta: { title: '资源库' } },
    { path: '/search', name: 'search', component: SearchView, meta: { title: '搜索' } },
    { path: '/content/:id', name: 'content-detail', component: ContentDetailView, meta: { title: '内容详情', backTo: '/library', backLabel: '返回资源库' } },
    { path: '/media/:id', name: 'media-detail', component: MediaDetailView, meta: { title: '媒体学习', backTo: '/library', backLabel: '返回资源库' } },
    { path: '/survey/:id', name: 'survey', component: SurveyView, meta: { title: '定向问卷', backTo: '/', backLabel: '返回首页' } },
    { path: '/messages', name: 'messages', component: MessagesView, meta: { title: '消息与订阅', backTo: '/profile', backLabel: '返回我的' } },
    { path: '/learning', name: 'learning', component: LearningView, meta: { title: '收藏与学习记录', backTo: '/profile', backLabel: '返回我的' } },
    { path: '/medical', name: 'medical', component: MedicalServiceView, meta: { title: '医学问询与 FAQ', backTo: '/', backLabel: '返回首页' } },
    { path: '/services', name: 'services', component: ServicesView, meta: { title: '服务', backTo: '/', backLabel: '返回首页' } },
    { path: '/profile', name: 'profile', component: ProfileView, meta: { title: '我的' } },
    { path: '/profile/consent', name: 'consent-settings', component: ConsentSettingsView, meta: { title: '隐私、授权与订阅', backTo: '/profile', backLabel: '返回我的' } },
    { path: '/meetings', name: 'meetings', component: MeetingsView, meta: { title: '会议' } },
    { path: '/meetings/:id', name: 'meeting-detail', component: MeetingDetailView, meta: { title: '会议详情', backTo: '/meetings', backLabel: '返回会议列表' } },
    { path: '/meetings/:id/watch', name: 'meeting-watch', component: MeetingJourneyView, meta: { title: '观看会议', backTo: '/meetings', backLabel: '返回会议详情' } },
    { path: '/meeting-journey', redirect: '/meetings/adc-summit/watch' },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
})

router.afterEach((to) => {
  const nextUrl = `${window.location.pathname}${window.location.search}#${to.fullPath}`
  const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`

  if (currentUrl !== nextUrl) {
    window.history.replaceState(window.history.state, '', nextUrl)
  }
})

export default router
